package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.selected
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.Color.white
import org.jetbrains.compose.web.dom.*

@Composable
private fun ActionButton(label: String, bgColor: CSSColorValue, onClick: () -> Unit) {
    Button(attrs = {
        onClick { onClick() }
        style {
            padding(10.px, 18.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
            backgroundColor(bgColor); borderRadius(8.px); cursor("pointer"); border(1.px, LineStyle.Solid, Color.black)
            property("transition", "all 0.2s ease")
            property("box-shadow", "0 2px 4px rgba(0,0,0,0.1)")
        }
    }) { Text(label) }
}
@Composable
fun GestionServiciosScreen(viewModel: AdminPanelViewModel, onBack: () -> Unit) {
    val uiState by viewModel.uiState.collectAsState()
    val rolesDAO = listOf("DIRECCION_DAO", "ASEO", "BASURA", "BACHE", "ILUMINACION", "SEMAFORO", "AUTO_ABANDONADO")
    val rolDB = (uiState.rolAdmin?.rol ?: "").uppercase().trim()
    val esSeguridad = rolDB == "SEGURIDAD_ADMIN"
    val rol = (uiState.rolAdmin?.rol ?: "").uppercase().trim()

    Div({
        style {
            padding(20.px)
            fontFamily("sans-serif")
            backgroundColor(Color("#1976D2")) // --- 🔵 AZUL INSTITUCIONAL TOTAL ---
            minHeight(100.vh)
        }
    }) {
    Div({
        style {
            height(95.vh)
            backgroundColor(Color("#1976D2"))
            borderRadius(12.px)
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            property("overflow-y", "auto")
        }
    }) {
        // --- CABECERA DE GALA ---
        Div({
            style {
                display(DisplayStyle.Flex)
                property("border-bottom", "2px solid #1565C0")
            }
        }) {
            Div({
                style {
                    width(10.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
                    alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
                }
            }) {
                Div({ style { display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(8.px) } }) {
                    Img(src = "logo_icon.svg", attrs = { style { height(120.px) } })
                    H2({ style { fontSize(24.px); color(Color.white); margin(0.px); property("text-shadow", "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                        Span({ style { fontWeight("normal") } }) { Text("Linea") }
                        Span({ style { fontWeight("bold") } }) { Text("Muni") }
                    }
                    P(attrs = { attr("translate", "no"); style { fontSize(16.px); color(Color("#FB8C00")); fontWeight("bold"); letterSpacing(1.px); margin(0.px) } }) { Text("SMART CITY") }
                }
            }

            Div({
                style {
                    width(90.percent); padding(16.px, 24.px); boxSizing("border-box")
                    display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); gap(16.px)
                }
            }) {
                H1({
                    style {
                        color(Color.white); fontSize(32.px); fontWeight(700); flex(1);
                        textAlign("center"); margin(0.px); paddingTop(20.px)
                    }
                }) { Text( "GESTION DE SERVICIOS") }
               // BARRA DE FILTROS Y ACCIONES
                Div({
                    style {
                        display(DisplayStyle.Flex)
                        flexDirection(FlexDirection.Column)
                        gap(16.px)
                        backgroundColor(Color.white)
                        padding(24.px)
                        borderRadius(12.px)
                        property("box-shadow", "0 4px 6px rgba(0,0,0,0.05)")
                        marginBottom(24.px)
                        boxSizing("border-box")
                    }
                }) {


                    // Fila de Filtros
                    Div({ style { display(DisplayStyle.Flex); gap(12.px); flexWrap(FlexWrap.Wrap); alignItems(AlignItems.Center) } }) {

                        val esGeneral = (uiState.rolAdmin?.rol ?: "").uppercase() == "GENERAL"

                            Div({
                                style {
                                    display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(12.px)
                                    padding(16.px); backgroundColor(Color("#E3F2FD")); borderRadius(8.px)
                                    marginBottom(12.px); border(1.px, LineStyle.Solid, Color("#2196F3"))
                                    width(100.percent); boxSizing("border-box"); flexWrap(FlexWrap.Wrap)
                                }
                            }) {
                                if (esGeneral) {
                                    // --- 🌍 ESCALABILIDAD NACIONAL: FILTRO EN CASCADA ---
                                    Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px) } }) {
                                        B({ style { color(Color("#1565C0")) } }) { Text("REGIÓN:") }
                                        Select({
                                            style { padding(8.px); borderRadius(4.px); minWidth(180.px) }
                                            onChange { viewModel.onFiltroRegionChanged(it.target.value) }
                                        }) {
                                            Option("", attrs = { if (uiState.filtroRegion == null) selected() }) { Text("-- Todas las Regiones --") }
                                            Option("NIVEL NACIONAL (MOLDES)", attrs = { if (uiState.filtroRegion == "NIVEL NACIONAL (MOLDES)") selected() }) { Text("🌍 NIVEL NACIONAL (MOLDES)") }
                                            uiState.regiones.forEach { region ->
                                                Option(region.nombre, attrs = { if (uiState.filtroRegion == region.nombre) selected() }) { Text(region.nombre) }
                                            }
                                        }
                                    }

                                    Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px); marginLeft(12.px) } }) {
                                        B({ style { color(Color("#1565C0")) } }) { Text("COMUNA:") }
                                        Select({
                                            style { padding(8.px); borderRadius(4.px); minWidth(200.px) }
                                            onChange { viewModel.onFiltroComunaGestionChanged(it.target.value) }
                                        }) {
                                            Option("", attrs = { if (uiState.filtroComunaGestion == null) selected() }) { Text("-- Seleccione Comuna --") }

                                            // Filtramos las comunas según la región elegida
                                            val comunasFiltradas = if (uiState.filtroRegion != null) {
                                                uiState.comunas.filter { it.regionDisplayName == uiState.filtroRegion }
                                            } else {
                                                emptyList()
                                            }

                                            comunasFiltradas.map { it.comunaDisplayName }.distinct().sorted().forEach { comuna ->
                                                Option(comuna, attrs = { if (uiState.filtroComunaGestion == comuna) selected() }) { Text(comuna) }
                                            }
                                        }
                                    }
                                }

                                if (esGeneral && uiState.filtroRegion == "NIVEL NACIONAL (MOLDES)") {
                                    Button(attrs = {
                                        onClick { viewModel.publicarAvisoNacional() }
                                        style {
                                            padding(10.px, 20.px); backgroundColor(Color("#D32F2F"))
                                            color(Color.white); borderRadius(8.px); cursor("pointer"); fontWeight("bold")
                                            border(0.px); marginRight(12.px)
                                        }
                                    }) { Text("📢 PUBLICAR AVISO NACIONAL") }
                                }

                                if (esGeneral || rol == "COMUNAL") {
                                    Button(attrs = {
                                        onClick { viewModel.onShowAgregarServicioModal() }
                                        style {
                                            padding(10.px, 20.px); backgroundColor(Color("#34A853"))
                                            color(Color.white); borderRadius(8.px); cursor("pointer"); fontWeight("bold")
                                            border(0.px)
                                        }
                                    }) { Text("+ Nuevo Servicio") }
                                }

                                // --- 🛡️ SOBERANÍA COMUNAL: El Alcalde o el General pueden sincronizar para bajar novedades ---
                                if (rol == "COMUNAL" || (esGeneral && uiState.filtroComunaGestion != null)) {
                                    Button(attrs = {
                                        onClick { viewModel.inyectarTodoDAO() }
                                        style {
                                            padding(10.px, 20.px); backgroundColor(Color("#FB8C00")); color(Color.white)
                                            border(0.px); borderRadius(6.px); cursor("pointer"); fontWeight("bold")
                                            marginLeft(12.px)
                                        }
                                    }) { Text("SINCRONIZAR SERVICIOS DAO") }
                                }

                                Div({ style { flex(1) } }) // 🛡️ EMPUJE TÁCTICO A LA DERECHA

                                Button(attrs = {
                                    onClick { onBack() }
                                    style {
                                        padding(10.px, 20.px); backgroundColor(Color("#FB8C00")) // 🟧 NARANJA INSTITUCIONAL
                                        color(Color.white); borderRadius(8.px); cursor("pointer"); fontWeight("bold")
                                        border(0.px)
                                    }
                                }) { Text("Volver al Panel") }
                        }
                    }
                }
            }
        }
///////////////////////

        // --- FILA 1: ENCABEZADO Y RECLUTAMIENTO ---
        Div({
            style {
                display(DisplayStyle.Flex);
                flexDirection(FlexDirection.Column)
                boxSizing("border-box");
                fontFamily("sans-serif")
                backgroundColor(Color("#1976D2"))
                property("border-bottom", "2px solid #1565C0");
                boxSizing("border-box")
            }
        }) {
        // --- CABECERA DE LA PANTALLA ---
                Div({
                    style {
                        display(DisplayStyle.Flex)
                        justifyContent(JustifyContent.SpaceBetween)
                        alignItems(AlignItems.Center)
                    }
                }) {
                    val comunaNombre = if (uiState.rolAdmin?.rol == "GENERAL") {
                        uiState.filtroComunaGestion ?: uiState.filtroComuna ?: "Nacional (Seleccione Comuna)"
                    } else {
                        uiState.rolAdmin?.comunaAsignadaDisplayName ?: "Global"
                    }
                    H1({ style { margin(0.px); color(Color.white); padding(20.px) } }) {
                        Text("Gestión de Servicios: $comunaNombre")
                    }
                }
        }
///////////////////////////////////////////////////////////////////////////////////////////
        // --- TARJETA DE CONTROL MAESTRO ---
        Div({
            style {
                display(DisplayStyle.Flex)
                width(100.percent)
            }
        }) {
            Div({
                style {
                    width(100.percent)
                    padding(0.px, 24.px, 24.px, 24.px)
                    boxSizing("border-box")
                }
            }) {
                Div({
                    style {
                        backgroundColor(Color("#1976D2"))
                        padding(24.px)
                        borderRadius(12.px)
                        property("box-shadow", "0 4px 6px rgba(0,0,0,0.1)")
                    }
                }) {
                    H3({
                        style {
                            marginTop(0.px)
                            marginBottom(24.px)
                            property("border-bottom", "1px solid #EEE")
                            paddingBottom(12.px)
                            color(white)
                        }
                    }) {
                        Text("Interruptores de Módulos Activos")
                    }

                    if (uiState.isLoading) {
                        Div({ style { textAlign("center"); padding(40.px) } }) { Text("Sincronizando servicios...") }
                    } else if (uiState.tiposIncidencia.isEmpty()) {
                        // --- 🚨 ALERTA DE JURISDICCIÓN VACÍA (SANKAN PROTOCOL) ---
                        Div({
                            style {
                                backgroundColor(Color("rgba(255,255,255,0.1)")); padding(40.px)
                                borderRadius(12.px); border(2.px, LineStyle.Dashed, Color.white)
                                textAlign("center"); color(white)
                            }
                        }) {
                            H2 { Text("🚨 JURISDICCIÓN SIN SERVICIOS") }
                            P({ style { fontSize(18.px) } }) { 
                                Text("Esta municipalidad aún no tiene servicios habilitados.") 
                            }
                            P({ style { fontSize(16.px); opacity(0.9) } }) { 
                                Text("Por favor, pulse el botón naranja ")
                                B { Text("[SINCRONIZAR SERVICIOS DAO]") }
                                Text(" para activar la matriz territorial básica.")
                            }
                        }
                    } else {
                        // --- DISEÑO PREMIUM DE CARDS (4 POR FILA) ---
                        Div({
                            style {
                                display(DisplayStyle.Grid)
                                // Forzamos 4 columnas fijas en desktop
                                gridTemplateColumns("repeat(4, 1fr)")
                                gap(24.px)
                            }
                        }) {
                            uiState.tiposIncidencia.sortedWith(compareBy({ it.comunaAsignadaDisplayName }, { it.orden })).forEach { tipo ->
                                // 🛡️ REGLA DE MANDO: Solo el Comunal o General pueden publicar/apagar servicios
                                val canActivate = rol == "COMUNAL" || rol == "GENERAL"
                                // El resto de permisos (editar/eliminar) se mantienen para el admin
                                val canEdit = uiState.rolAdmin != null

                                Div({
                                    style {
                                        backgroundColor(Color.white)
                                        borderRadius(16.px)
                                        padding(24.px)
                                        display(DisplayStyle.Flex)
                                        flexDirection(FlexDirection.Column)
                                        property("box-shadow", "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)")
                                        border(1.px, LineStyle.Solid, Color("#E2E8F0"))
                                        property("transition", "transform 0.2s, box-shadow 0.2s")
                                    }
                                }) {
                                    // Cabecera: Nombre y Comuna
                                    Div({ style { marginBottom(16.px) } }) {
                                        H3({
                                            style {
                                                margin(0.px)
                                                fontSize(20.px)
                                                color(Color("#1A202C"))
                                                fontWeight("700")
                                            }
                                        }) { Text(tipo.nombreDisplay ?: tipo.nombre) }

                                            Span({
                                                style {
                                                    fontSize(12.px); color(Color("#3182CE"))
                                                    backgroundColor(Color("#EBF8FF")); padding(4.px, 12.px)
                                                    borderRadius(20.px); marginTop(8.px); display(DisplayStyle.InlineBlock)
                                                    fontWeight("600")
                                                }
                                            }) { Text("📍 ${tipo.comunaAsignadaDisplayName ?: "Global"}") }
                                    }

                                    // Estado y Botón de Encendido
                                    Div({
                                        style {
                                            display(DisplayStyle.Flex);
                                            alignItems(AlignItems.Center)
                                            justifyContent(JustifyContent.SpaceBetween);
                                            property("margin-top", "auto")
                                            paddingTop(16.px);
                                            property("border-top", "1px solid #EDF2F7")
                                        }
                                    }) {
                                        Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); gap(8.px) } }) {
                                            Div({
                                                style {
                                                    width(8.px); height(8.px); borderRadius(50.percent)
                                                    backgroundColor(if (tipo.estaActivo) Color("#48BB78") else Color("#F56565"))
                                                }
                                            })
                                            Span({
                                                style {
                                                    fontSize(14.px); fontWeight("600")
                                                    color(if (tipo.estaActivo) Color("#48BB78") else Color("#F56565"))
                                                }
                                            }) { Text(if (tipo.estaActivo) "ACTIVADO" else "DESACTIVADO") }
                                        }

                                        Button(attrs = {
                                            if (!canActivate) {
                                                disabled()
                                                title("Solo el Administrador Comunal puede cambiar el estado")
                                            }
                                            onClick { viewModel.onCambiarEstadoServicio(tipo, tipo.estaActivo) }
                                            style {
                                                padding(8.px, 16.px); borderRadius(10.px); cursor(if (canActivate) "pointer" else "not-allowed")
                                                border(0.px); color(Color.white); fontWeight("bold")
                                                fontSize(13.px)
                                                backgroundColor(if (canActivate) (if (tipo.estaActivo) Color("#ED8936") else Color("#4299E1")) else Color("#cccccc"))
                                            }
                                        }) { Text(if (tipo.estaActivo) "OFF" else "ON") }
                                    }

                                    // --- 🛡️ BLOQUEO DE ESTRUCTURA: Los nombres de servicios son fijos para mantener el orden nacional ---
                                }
                            }
                        }
                    }
                }

        // --- NOTA AL PIE ---
                P({
                    style {
                        marginTop(24.px)
                        color(Color("#666"))
                        fontSize(14.px)
                        fontStyle("italic")
                        backgroundColor(Color("#FFF3E0"))
                        padding(16.px)
                        borderRadius(8.px)
                        property("border-left", "4px solid #FF9800")
                    }
                }) {
                    Text("Nota: El Administrador Comunal es el único facultado para activar o crear nuevos servicios locales. Los servicios marcados como 'Global' son estandarizados a nivel nacional.")
                }
                    // --- RE-ACTIVACIÓN DE MODALES PARA EL COMUNAL ---
                    if (uiState.showAgregarServicioModal && (rol == "COMUNAL" || rol == "GENERAL")) {
                        AgregarServicioModal(
                            admin = uiState.rolAdmin,
                            comunas = uiState.comunas,
                            onDismiss = { viewModel.onHideAgregarServicioModal() },
                            onConfirm = { nombre, nombreDisplay, depto, cRef, cName ->
                                viewModel.onCrearNuevoServicio(nombre, nombreDisplay, depto, cRef, cName)
                            }
                        )
                    }
                }
           }
        }
    }
}